import React, { useEffect, useState } from 'react'
import { SendNotificationAPI } from '../redux/actions/send-notification/PostNotificationAction';
import { useDispatch, useSelector } from 'react-redux';
import { showErrorToast, showSuccessToast } from '../helpers/SweetAlert';
import { postNotificationStateReset } from '../redux/slices/send-notification/PostNotificationSlice';

const SendNotification = () => {

    const dispatch = useDispatch();
    const [userType, setUserType] = useState('');
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [validationErrors, setValidationErrors] = useState('');

    const { response, loading, error } = useSelector((state) => state.sendNotification)

    const validateForm = () => {
        const newErrors = {};

        if (!title.trim()) newErrors.title = true;
        if (!description.trim()) newErrors.description = true;

        setValidationErrors(newErrors);

        return Object.keys(newErrors).length === 0; // true if no errors
    };

    const handleSubmit = async () => {
        if (!validateForm()) { return };

        const data = { type: userType, title: title, message: description };

        await dispatch(SendNotificationAPI(data));
    }
    useEffect(() => {
        if (response?.status === true) {
            showSuccessToast(response?.message);
            dispatch(postNotificationStateReset());
            setTitle('');
            setDescription('');
            setUserType('');
        }
        if (error) {
            showErrorToast(error?.data);
            dispatch(postNotificationStateReset());
            setTitle('');
            setDescription('');
            setUserType('');
        }
    }, [response, error]);

    return (
        <div className="content-wrapper">
            <section className="main-section push-notification spacer">
                <div className="container">
                    <div className="wrapper-card">
                        <div className="row justify-content-start">
                            <div className="col-xl-6">
                                <form>
                                    <div className="push-main-wrapper">
                                        <div className="row gy-4">
                                            <div className="col-lg-12">
                                                <div className="label_title">
                                                    <h2 className="fs-6 mb-1">Select User</h2>
                                                </div>
                                                <div className="form_field p-relative">
                                                    <select className='form-select' value={userType} onChange={(e) => setUserType(e.target.value)}>
                                                        <option value="1">All</option>
                                                        <option value="2">Suppliers</option>
                                                        <option value="3">Customers</option>
                                                        <option value="4">Restaurants</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="label_title">
                                                    <h2 className="fs-6 mb-1">Title</h2>
                                                </div>
                                                <div className="form_field p-relative">
                                                    <input type="text" className={`form-control ${validationErrors.title ? 'is-invalid' : ''}`} placeholder='Enter title' value={title} onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value.length === 1 && value === ' ') return;
                                                        setTitle(value);
                                                        if (validationErrors.title) {
                                                            setValidationErrors(prev => ({ ...prev, title: false }));
                                                        }
                                                    }} />
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="label_title">
                                                    <h2 className="fs-6 mb-1">Enter Description</h2>
                                                </div>
                                                <div className="form_field p-relative">
                                                    <textarea className={`form-control ${validationErrors.description ? 'is-invalid' : ''}`} placeholder='Enter Description' rows={6} value={description} onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value.length === 1 && value === ' ') return; // block leading space
                                                        setDescription(value);
                                                        if (validationErrors.description) {
                                                            setValidationErrors(prev => ({ ...prev, description: false }));
                                                        }
                                                    }}></textarea>
                                                </div>
                                            </div>
                                            <div className="col-xxl-12">
                                                <div className="push-notification-btn d-flex justify-content-center">
                                                    <button type="button" className="primary-btn" onClick={handleSubmit}>Send</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div >
                    </div >
                </div >
            </section >
        </div >
    )
}

export default SendNotification